
import React from "react";
import { ProjectState, queueExport } from "../../../shared";
import ObjectDetectionControls from "./objects/ObjectDetectionControls";
import { useNavigate } from "react-router-dom";

type Props = {
  project: ProjectState
}

function RightControls({ project }: Props) {
  const navigate = useNavigate();

  const onClickExport = async () => {
    console.log("onClickExport", project);
    const key = await queueExport(project.projectId);
    console.log("key", key);
    navigate(`/exports/${project.projectId}`);
  }

  return (
    <div style={{
      display: 'flex',
      width: '100%',
      overflow: 'scroll',
      flexDirection: 'column',
      flex: 1,
    }}>
      <div 
        style={{
          color: 'white',
          backgroundColor: 'black',
          padding: 16,
          margin: 16,
          borderRadius: 8,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={onClickExport}
      >
        Export
      </div>
      <ObjectDetectionControls project={project} />
    </div>
  );
}

export default RightControls;